import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../supabase';
import { formatCurrency } from '../utils/formatters';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const PropertyDetail = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    fetchProperty();
  }, [id]);

  const fetchProperty = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('listings_final_v1')
      .select('*')
      .eq('id', id)
      .single();

    if (!error && data) {
      setProperty(data);
      setActiveImage(data.cover_index || 0);
    }
    setLoading(false);
  };

  if (loading) return <div className="py-20 text-center">Cargando...</div>;
  if (!property) return <div className="py-20 text-center">Propiedad no encontrada.</div>;

  const images = property.images && property.images.length > 0 
    ? property.images 
    : [{ src: 'https://via.placeholder.com/1200x800' }];

  const contactWhatsApp = () => {
    const phone = property.agent_phone?.replace(/\D/g, '') || '50499999999';
    const message = `Hola, estoy interesado en ${property.property_type} en ${property.city}.`;
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <Link to="/" className="text-emerald-600 font-bold flex items-center gap-2 mb-6">
        <SafeIcon icon={FiIcons.FiArrowLeft} /> Volver al inicio
      </Link>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        
        <div className="lg:col-span-2 space-y-6">
          {/* Contenedor de la imagen principal actualizado */}
          <div className="aspect-video rounded-3xl overflow-hidden shadow-lg border border-gray-100 bg-gray-100 p-2 flex items-center justify-center">
            <img 
              src={images[activeImage].src} 
              className="w-full h-full object-contain rounded-2xl" 
              alt="Propiedad" 
            />
          </div>

          <div className="grid grid-cols-5 gap-2">
            {images.map((img, i) => (
              <button 
                key={i} 
                onClick={() => setActiveImage(i)}
                className={`aspect-square rounded-xl overflow-hidden border-2 ${activeImage === i ? 'border-emerald-500' : 'border-transparent'}`}
              >
                <img src={img.src} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100">
            <h1 className="text-3xl font-black text-gray-900 mb-2">{property.property_type} en {property.city}</h1>
            <p className="text-gray-500 mb-6">{property.address}, {property.state}</p>
            
            <div className="prose max-w-none text-gray-700 whitespace-pre-wrap leading-relaxed">
              {property.description}
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-emerald-900 p-8 rounded-[2.5rem] text-white shadow-2xl">
            <p className="text-emerald-400 text-xs font-black uppercase tracking-widest mb-2">Inversión Solicitada</p>
            <p className="text-4xl font-black mb-8">{formatCurrency(property.price, property.currency)}</p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3 bg-white/10 p-4 rounded-2xl">
                <SafeIcon icon={FiIcons.FiUser} className="text-emerald-400" />
                <div>
                  <p className="text-[10px] font-bold text-emerald-400 uppercase">Asesor</p>
                  <p className="font-bold">{property.agent_name || 'Agente Arboleda'}</p>
                </div>
              </div>
            </div>

            <button 
              onClick={contactWhatsApp}
              className="w-full bg-emerald-500 text-emerald-950 font-black py-4 rounded-2xl hover:bg-emerald-400 transition-all flex items-center justify-center gap-2"
            >
              <SafeIcon icon={FiIcons.FiMessageCircle} className="text-xl" />
              CONTACTAR AHORA
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PropertyDetail;